import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { buildLiveEventsCalendarUrl } from '../../features/market-analytics/components/helpers/calendarLinks'

/**
 * TEMPORARY REDIRECT — the Game Level Blueprint Detail page was retired in favor of the
 * customer Live Events calendar (Erno's feedback, reskins-continuum). The route
 * `/market-analytics/:blueprintId/game-level/:gameId?/:variant?` is kept — still on the old
 * `market-analytics` prefix from before the tool was renamed Live Event Analytics — so old
 * links and bookmarks keep working, but it now redirects straight to the game's calendar
 * view (grouped by blueprint), or to the Live Event Analytics catalogue when the link has
 * no game. `:gameId` must stay optional: without it the generic `/market-analytics/*`
 * forward produces a `/live-event-analytics/.../game-level` path no route matches. Resolving a representative event for the blueprint modal
 * would require blocking on extra queries, so the redirect goes to the plain calendar
 * instead. Remove this page (and its PageService/AppRoutes entries) once the route can be
 * dropped.
 */
const GameLevelBlueprintDetailPage: React.FC = () => {
  const { gameId } = useParams<{ blueprintId: string; gameId: string; variant?: string }>()
  return <Navigate replace to={gameId ? buildLiveEventsCalendarUrl({ gameId }) : '/live-event-analytics'} />
}

export default GameLevelBlueprintDetailPage
